import { inject, Injectable } from '@angular/core';
import { first, map, Observable } from 'rxjs';

import { CurrentUser, PrivaAuthCurrentUserService } from '@priva/auth/current-user';
import { PrivaLocalizationService } from '@priva/localization';

@Injectable({ providedIn: 'root' })
export class AppShellUserInfoService extends PrivaAuthCurrentUserService {
    privaLocalizationService = inject(PrivaLocalizationService);

    readonly user: Observable<CurrentUser>;
    constructor() {
        super();
        this.user = this.privaLocalizationService.translate('GENERAL.TITLE.USER_INFO').pipe(
            first(),
            map((translatedTitle) => ({
                name: translatedTitle,
                tenantName: '',
                tenantId: '',
            })),
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    login(): void {}
}
